
/**
 * 플랜 상태
 */
export type PlanChangeOptionsResponseDowngradeOptionsItemStatus = typeof PlanChangeOptionsResponseDowngradeOptionsItemStatus[keyof typeof PlanChangeOptionsResponseDowngradeOptionsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanChangeOptionsResponseDowngradeOptionsItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
